export const MESSAGES = {
  WHATSAPP_INTEREST:
    "Olá, tenho interesse no imóvel {{type}} - {{neighborhood}} de código {{code}}. Poderia me ajudar?",
  WHATSAPP_SCHEDULE:
    "Olá, queria agendar uma visita no imóvel {{type}} - {{neighborhood}} de código {{code}}. Qual dia podemos marcar?",
  SHARE_TEXT: "Confira este imóvel: {{type}} - {{neighborhood}}, Cód. {{code}}",
} as const;

export function formatMessage(
  template: string,
  data: Record<string, string | number>,
): string {
  return template.replace(/{{\s*(\w+)\s*}}/g, (_, key: string) =>
    data[key] !== undefined ? String(data[key]) : `{{${key}}}`,
  );
}
